import type { Result } from '@lved/shared-core/types/window-types';

export const INVALID_FILE_OR_DIRECTORY_VARIABLE_NAME_MESSAGE: string = 'File/Directory must be a valid variable name.';

export const createInvalidFileOrDirectoryNameResult = (path: string): Result => ({
    success: false,
    error: `Invalid file or directory name: ${path}`
});
